import { render, staticRenderFns } from "./PrintPackingList.vue?vue&type=template&id=36f38472&scoped=true"
import script from "./PrintPackingList.vue?vue&type=script&lang=js"
export * from "./PrintPackingList.vue?vue&type=script&lang=js"
import style0 from "./PrintPackingList.vue?vue&type=style&index=0&id=36f38472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f38472",
  null
  
)

export default component.exports